import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import {
  subscribe,
  fetch,
  onDelete as deleteNotification,
  markRead as markNotificationRead
} from "APP_ROOT/Nav/Notifications/actions";
import { dismissibleChild } from "MODULES/shared/decorators";
import { filters } from "MODULES/Notifications/components/Search/Search";
import Notification from "./Notification";
import FilterDropdown from "./FilterDropdown";

const getTrueKey = obj => Object.keys(obj).find(key => obj[key]);

const getIcon = key => {
  if (!key) return "Filters";
  const filter = filters.find(obj => obj.key === key);

  return (filter && filter.label) || "Filters";
};

class Notifications extends Component {
  static propTypes = {
    stale: PropTypes.bool.isRequired,
    fetchNotifications: PropTypes.func.isRequired,
    markRead: PropTypes.func.isRequired,
    notifications: PropTypes.instanceOf(Array).isRequired,
    onDelete: PropTypes.func.isRequired,
    subscribeToNotification: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    unreadCount: PropTypes.number,
    contentRef: PropTypes.func.isRequired
  };

  state = {
    filters: {},
    expanded: false
  };

  componentDidMount() {
    this.props.fetchNotifications();
    this.props.subscribeToNotification();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.stale && !this.props.stale) {
      nextProps.fetchNotifications();
    }
  }

  render() {
    const {
      notifications,
      onDelete,
      markRead,
      visible,
      toggle,
      contentRef,
      fetchNotifications,
      unreadCount
    } = this.props;

    const { expanded } = this.state;

    const classes = classNames("navbar-notifications", { open: visible });

    const expandClasses = classNames("navbar-notifications-list", { expanded });
    const badgeClasses = classNames("badge", {
      danger: unreadCount && unreadCount > 0
    });
    return (
      <li className={classes} ref={contentRef}>
        <a
          id="notifications"
          className="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          onClick={toggle}
        >
          <i className="fa fa-fw fa-lg fa-bell" />
          <span className="hidden-md hidden-lg"> Notifications</span>&nbsp;
          <span className={badgeClasses}>{unreadCount}</span>
        </a>
        <ul className="dropdown-menu notification-panel" role="menu">
          <li className="text-center">
            <div className="row row-col-gutters-half">
              <div className="col-xs-12 navbar-notifications-filters">
                <FilterDropdown
                  title={getIcon(getTrueKey(this.state.filters))}
                  setFilters={params => {
                    this.setState({ filters: params });
                    fetchNotifications(params);
                  }}
                />
              </div>
            </div>
          </li>
          <li className={expandClasses}>
            <ul className="dropdown-menu-nested">
              {notifications.map(n => (
                <Notification
                  notification={n}
                  onDelete={onDelete}
                  markRead={markRead}
                />
              ))}
            </ul>
          </li>
          {(notifications.length === 0 && (
            <li>
              <a>You have zero notifications at this time.</a>
            </li>
          )) || (
            <li
              onClick={() => this.setState({ expanded: !expanded })}
              className="text-center pointer"
              style={{ borderTop: "1px solid rgba(0, 0, 0, 0.1)" }}
            >
              <span
                className={`fa fa-caret-${expanded ? "up" : "down"} fa-lg`}
              />
            </li>
          )}
        </ul>
      </li>
    );
  }
}

export default dismissibleChild(
  connect(
    state => ({
      notifications: state.notifications.get("notifications").toJS(),
      stale: state.notifications.get("stale"),
      unreadCount: state.notifications.get("unreadCount")
    }),
    dispatch => ({
      fetchNotifications: params =>
        dispatch(
          fetch(
            Object.assign({
              page: 1,
              limit: 20,
              sort: "id",
              reverse: true,
              filter: true,
              ...params
            })
          )
        ),
      onDelete: id => dispatch(deleteNotification(id)),
      markRead: id => dispatch(markNotificationRead(id)),
      subscribeToNotification: () => dispatch(subscribe())
    })
  )(Notifications)
);



// WEBPACK FOOTER //
// ./app/Nav/Notifications/Notifications.jsx